import { PROPOSAL_ACCENT, PROPOSAL_COPY_FONT, PROPOSAL_TEXT } from "@/lib/proposalTheme";
import { PDF_BODY_CLASS, PDF_DESC_CLASS, PDF_EYEBROW_CLASS } from "@/lib/proposalPdfTypography";

type Props = {
  amountFormatted: string;
  story?: string | null;
  testId?: string;
};

/** Gold-bordered system value strip near the top of each system PDF section. */
export default function DtoolsPdfSystemValueBar({
  amountFormatted,
  story,
  testId = "dtools-pdf-system-value",
}: Props) {
  return (
    <div
      className="pdf-keep-together space-y-1.5 rounded-lg border border-[#C8A96A]/60 bg-[#FAFAF7] px-4 py-2.5"
      data-testid={testId}
      style={{ fontFamily: PROPOSAL_COPY_FONT }}
    >
      <div className="flex items-center justify-between gap-4">
        <p className={PDF_EYEBROW_CLASS} style={{ color: PROPOSAL_ACCENT }}>
          System Value
        </p>
        <p className="text-lg font-semibold tabular-nums" style={{ color: PROPOSAL_TEXT }}>
          {amountFormatted}
        </p>
      </div>
      {story ? <p className={`${PDF_DESC_CLASS} leading-snug`}>{story}</p> : null}
    </div>
  );
}
